import React, { useState, useEffect } from 'react';
import { SponsorContext } from './DataContext';
import axios from "axios"; 
import config from '../components/configuration/config'; 

export const SponsorState = ({ children }) => {
  const [isSponsors, setAllSponsors] = useState([]);
  const [isSponsorsLoading, setSponsorsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sponsors_past_event, setPastEvent] = useState(false);
  const [sponsors_current_event, setCurrentEvent] = useState(false); 
  const [sponsors_categories, setSponsorsCategories] = useState([]);
 
 
  
  const apiUrl = 'https://apievt.lacnic.net/wp-json/wp/v2';
  const pageParam = '?per_page=100';

  // Cargar todos los sponsors
  useEffect(() => {
    async function loadSponsors() {
      try {
        const sponsors = [];
        const response = await fetch(`${apiUrl}/sponsors`);
        if (!response.ok) {
          throw new Error(`Failed to fetch sponsors: ${response.status} ${response.statusText}`);
        }
        const totalPages = response.headers.get('X-WP-TotalPages');
        for (let i = 1; i <= totalPages; i++) {
          const pageResponse = await fetch(`${apiUrl}/sponsors?page=${i}`);
          if (!pageResponse.ok) {
            throw new Error(`Failed to fetch sponsors for page ${i}: ${pageResponse.status} ${pageResponse.statusText}`);
          }
          const pageSponsors = await pageResponse.json();
          sponsors.push(...pageSponsors);
        }
        setAllSponsors(sponsors);
        setSponsorsLoading(true);
      } catch (error) {
        console.error(error);
      }
    }
    loadSponsors();
  }, [apiUrl]);

    // Cargar sponsors del evento pasado y actual
    useEffect(() => {
      const fetchSponsors = async () => {
        // Solo ejecutar si tenemos los IDs de eventos
        if (config?.currentEventID && config?.pastEventID) {
          setLoading(true);
          try {
            // Parámetros de paginación
            const perPage = 100; // Puedes ajustar este número según necesites
            const params = `${pageParam}&per_page=${perPage}`;
  
            // Fetch sponsors del evento pasado
            const pastResponse = await axios.get(
              `${apiUrl}/sponsors?${params}&our_events=${config?.pastEventID}`
            );
            setPastEvent(pastResponse.data);
  
            // Fetch sponsors del evento actual
            const currentResponse = await axios.get(
              `${apiUrl}/sponsors?${params}&our_events=${config?.currentEventID}`
            );
            setCurrentEvent(currentResponse.data);
          } catch (error) {
            console.error('Error fetching sponsors:', error);
          } finally {
            setLoading(false);
          }
        }
      };
  
      fetchSponsors();
    }, [apiUrl]);
  
  // Cargar categorías de sponsors
  useEffect(() => {
    const fetchCategoriesSponsors = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/category_sponsors${pageParam}`);
        setSponsorsCategories(response.data);
      } catch (error) {
        console.error('Error fetching sponsor categories:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategoriesSponsors();
  }, [apiUrl]);

  return (
    <SponsorContext.Provider value={{
      isSponsors,
      isSponsorsLoading,
      loading, 
      sponsors_current_event,
      sponsors_past_event,
      sponsors_categories
    }}>
      {children}
    </SponsorContext.Provider>
  );
}; 